/**
 * @description entry
 */
import line from '@/core/line';
import bar from '@/core/bar';
import pie from '@/core/pie';
import radius from '@/core/radius';

export default {
    line,
    bar,
    pie,
    radius,
    Line: line,
    Bar: bar,
    Pie: pie,
    Radius: radius,
};
